import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const ModalComponent = ({ children, open, handleClose, title }) => {
    return (
        <>
            <Dialog maxWidth={"lg"} open={open} onClose={handleClose}>
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>{children}</DialogContent>
            </Dialog>
        </>
    );
};

export default ModalComponent;
